module.exports = __webpack_public_path__ + "img/performance2.35456a97.svg";